import React, { useState } from 'react';
import styles from './style.module.css';
import Typography from '../components/Typography/Typography';
import { FAQHeroImage } from '../assets/webp';
import { useNavigate } from 'react-router';
import AnimatedButton from '../components/AnimatedButton';

interface FAQItem {
  id: number;
  question: string;
  answer: string;
}

export const FAQSection: React.FC = () => {
  const [activeIndex, setActiveIndex] = useState<number>(0);
  const navigate = useNavigate();
  const faqData: FAQItem[] = [
    {
      id: 1,
      question: "What devices does OpenX work on?",
      answer: "OpenX works seamlessly on mobile devices, tablets, desktops, and most modern VR headsets so you can create or explore from anywhere."
    },
    {
      id: 2,
      question: "Is my information secure on OpenX?",
      answer: "Yes, we take security seriously. OpenX uses enterprise-grade encryption and follows industry best practices to protect your personal information and data."
    },
    {
      id: 3,
      question: "Can I contact the artist or buyer directly?",
      answer: "Absolutely! OpenX provides secure messaging features that allow you to communicate directly with artists and buyers while maintaining privacy and safety."
    },
    {
      id: 4,
      question: "Can I contact the artist or buyer directly?",
      answer: "Yes, our platform includes built-in communication tools that facilitate direct contact between users while ensuring secure transactions."
    },
    {
      id: 5,
      question: "Is my information secure on OpenX?",
      answer: "Your data security is our top priority. We employ advanced security measures including SSL encryption, secure payment processing, and regular security audits."
    }
  ];

  const toggleFAQ = (index: number): void => {
    setActiveIndex(activeIndex === index ? -1 : index);
  };

  const handleContactClick = () => 
  {
    navigate("/contact");
  }

  return (
    <div className={styles.faqContainer}>
      <div className={styles.faqContent}>
        {/* Header Section */}
        <div className={styles.headerSection}>
          <div className={styles.textSection}>
            <Typography
            variant="heading2"
            fontFamily="satoshi"
            weight="bold"
             className={styles.faqTitle}>
              Here are some answers
              to your Questions
            </Typography>
          </div>
          
          <div className={styles.heroImageSection}>
            <div className={styles.heroImage}>
                <img
                src={FAQHeroImage}
                alt='forest landscape'
                className={styles.heroImg}
                />
            </div>
          </div>
        </div>

        {/* FAQ Items */}
        <div className={styles.faqList}>
          {faqData.map((faq, index) => (
            <div 
              key={faq.id}
              className={`${styles.faqItem} ${activeIndex === index ? styles.active : ''}`}
            >
              <button 
                className={styles.faqQuestion}
                onClick={() => toggleFAQ(index)}
                aria-expanded={activeIndex === index}
              >
                <Typography 
                variant='bodyRegular'
                fontFamily='satoshi'
                className={styles.questionText}>
                    {faq.question}
                    </Typography>
                <span className={`${styles.expandIcon} ${activeIndex === index ? styles.expanded : ''}`}>
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path 
                      d="M5 7.5L10 12.5L15 7.5" 
                      stroke="currentColor" 
                      strokeWidth="2" 
                      strokeLinecap="round" 
                      strokeLinejoin="round"
                    />
                  </svg>
                </span>
              </button>
              
              <div className={`${styles.faqAnswer} ${activeIndex === index ? styles.showAnswer : ''}`}>
                <div className={styles.answerContent}>
                  <Typography 
                  variant='bodyRegular'
                  fontFamily='satoshi'
                  size='base'
                  className={styles.answerText}>
                    {faq.answer}
                    </Typography>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className={styles.contactSection}>
          <Typography 
          variant='bodyRegular'
          fontFamily='satoshi'
          className={styles.contactText}>
            Still got questions?
            </Typography>
          <AnimatedButton
          variant='primary'
          className={styles.contactButton}
          onClick={handleContactClick}
          >
            <Typography
            variant='buttonText'
            fontFamily='satoshi'
            size='base'
            className={styles.contatctButtonText}>
            Contact
            </Typography>
          </AnimatedButton>
        </div>
      </div>
    </div>
  );
};